<template>
  <mdb-container fluid>
    <DataTableAG
      deleteparam="retailerids"
      :columns="columns"
      width="850px"
      height="750px"
      :archivecontentpath="retailersarchivepath"
      archiveparam="retailerids"
      :getcontentpath="retailersspath"
      :buttonList="['Muokkaa']"
      jsonobject="retailers"
      v-on:pressed-button1="editRetailer"
      deleteEnabled
      retailerCopyEnabled
    />
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import DataTableAG from "../components/DataTableAG.vue";
export default {
  name: "Retailers",
  components: {
    mdbContainer,
    DataTableAG,
  },
  methods: {
    editRetailer(rowData) {
      this.$router.push("/addretailer/" + rowData.id);
    },
    deleteRetailer(rowData) {
      console.log(rowData);
    },
  },
  data: () => ({
    loadReady: false,
    retailerChainId: 0,
    retailerId: 0,
    retailers: [],
    labelOptions: [],
    retailersspath: "/1.0/front/retailers",
    retailersarchivepath: "/1.0/front/retailers/delete",
    columns: [
      {
        field: "name",
        headerName: "Toimipaikan nimi",
        width: 300,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "addr1",
        headerName: "Osoite 1",
        width: 200,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "town",
        headerName: "Kaupunki",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() {},
};
</script>

<style></style>
